import { supabase } from "@/lib/supabase";
import { api } from "@/lib/api";

export async function loadDriverContext() {
  const { data: drivers } = await supabase
    .from("drivers")
    .select("id, full_name, email, mobile_number, employee_reference, customer_id, customers(id, name, pod_id, support_phone, emergency_phone, instructions, hire_policy)")
    .limit(1);
  const driver = drivers?.[0] || null;
  const { data: allocs } = await supabase
    .from("driver_allocations")
    .select("id, start_at, status, vehicle_id, vehicles(*)")
    .eq("status", "active")
    .limit(1);
  const allocation = allocs?.[0] || null;
  return { driver, customer: driver?.customers || null, allocation, vehicle: allocation?.vehicles || null };
}

export async function loadDriverBookings() {
  const { data } = await supabase
    .from("v_driver_bookings")
    .select("*")
    .order("created_at", { ascending: false });
  return data || [];
}

export async function createBooking(ctx, fields) {
  const id = crypto.randomUUID();
  const payload = {
    id,
    customer_id: ctx.driver.customer_id,
    pod_id: ctx.customer?.pod_id || null,
    vehicle_id: ctx.vehicle?.id || null,
    driver_id: ctx.driver.id,
    allocation_id: ctx.allocation?.id || null,
    internal_status: "new_request",
    public_status: "Request received",
    created_by_user_id: ctx.driver.auth_user_id || null,
    ...fields,
  };
  const { error } = await supabase.from("booking_requests").insert(payload);
  if (error) throw error;
  // seed the timeline with the request-received record
  await supabase.from("booking_updates").insert({
    booking_request_id: id,
    update_type: "created",
    internal_status: "new_request",
    public_status: "Request received",
    public_message: "We have received your request.",
    source: "driver",
  });
  // Record mileage historically via the backend (service-key, validated). Best-effort:
  // a booking must never fail because the mileage side-record failed.
  if (fields.mileage != null && fields.mileage !== "") {
    try {
      await api.driverMileage({
        mileage: Number(fields.mileage),
        vehicle_id: ctx.vehicle?.id || null,
        booking_request_id: id,
        source: "driver_request",
      });
    } catch (_) { /* non-fatal */ }
  }
  return id;
}
